import {empty} from "../Core/common";
import {notice} from "../UI/notice";
import config from "../../Config/config";

const cart = (self, events, callback) => {
    let productId = self.dataset.id;
    let basketId = self.dataset.basket_id;
    let chose = self.dataset.chose || 0;

    let form = self.closest('.js_item');
    let countComponent = form.querySelector('.count_product_item');

    let cnt = 1;
    if (countComponent) {
        cnt = countComponent.value;
    }

    if (empty(cnt)) {
        cnt = 1;
    }

    const dataJson = {};

    form.querySelectorAll('[data-choise="true"]:checked').forEach(item => {
        dataJson[item.getAttribute('name')] = item.value;
    });

    let output = {
        action: basketId ? 'rebuildcard' : 'addtocart',
        product_id: productId,
        basket_id: basketId,
        chose: chose,
        data_json: dataJson,
        count: cnt,
    };


    (async () => {
        try {
            self.classList.add('preloader');
            const rawResponse = await fetch(`/includes/modules/cart/cart_functions.php`, {
                mode: 'cors',
                method: 'POST',
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                body: 'data=' + JSON.stringify(output)
            });
            const content = await rawResponse.json();

            if (content.success) {
                if (['/cart.html', '/basket.html'].includes(document.location.pathname)) {
                    document.location.reload();
                    return;
                }

                events.dispatch(config.listeners.basket.added, content);
                if (!basketId) {
                    let block = `<div class="count-number p-5 bg-light rounded-pill position-relative align-items-center product-item-count d-flex">                                
                        <div class="count-btn count-btn-min rounded-circle p-10 bg-white border-0 d-flex pointer" aria-label="btn-min">
                            <i class="remove fs-18 text-main"></i>
                        </div>    
                        <label class="flex-grow-1">
                            <input class="p-0 border-0 text-black fw-bold count-input bg-transparent w-100 count_product_item" data-basket_id="${content.basket_id}"
                                type="text" min="1" value="${content.count_item}" max="9999" style="width: 1ch;">
                        </label>                                    
                        <div class="count-btn count-btn-plus rounded-circle p-10 bg-white border-0 d-flex pointer" aria-label="btn-plus">
                            <i class="plus fs-18 text-main"></i>
                        </div>  
                    </div>`;
                    let blockItem = self.closest('.product-changeBlock');
                    blockItem.innerHTML = block;

                    setTimeout(
                        callback.bind(null, blockItem, events), 20
                    );
                }

                if (cnt < content.count_item) {
                    notice('Товар добавлен в корзину.');
                } else {
                    notice('Количество товара обновлено.');
                }

            } else {
                notice(content.error);
            }
        } catch (e) {
            notice('Не удалось выполнить действие');
        } finally {
            self.classList.remove('preloader');
        }
    })();

};

const newCount = (item, events) => {
    let plus = item.querySelector('.count-btn-plus');
    let min = item.querySelector('.count-btn-min');
    let input = item.querySelector('.count-input');

    plus.addEventListener('click', () => {
        +input.value++;
        if (+input.value >= 999) {
            input.value = 999;
        }
        input.dispatchEvent(new Event("change"));
    });

    min.addEventListener('click', () => {
        +input.value--;
        if (+input.value < 1) {
            input.value = 1;
        }
        input.dispatchEvent(new Event("change"));
    });

    let timer = null;
    input.addEventListener('change', () => {
        clearTimeout(timer);
        let val = +input.value.replace(/[^0-9]/g, '');

        if (val < 1) {
            input.value = 1;
        } else if (val >= 999) {
            input.value = 999;
        } else {
            input.value = val;
        }
        timer = setTimeout(() => cart(input, events), 600);
    });
};

export const addToCart = (events, evt) => {
    evt.preventDefault();
    evt.stopPropagation();

    let self = evt.currentTarget || evt.target;

    cart(self, events, newCount);
};
